<template>
  <v-row class="root">
    <v-col>
      <v-skeleton-loader class="header-loading-1 d-flex align-center justify-space-between" :loading="loading" type="heading">
        <v-row>
          <v-col :class="`col-12 ${$slots.default ? 'col-md-6' : ''}`">
            <h1>{{title}}</h1>
          </v-col>
          <v-col v-if="$slots.default" class="col-12 col-md-6">
            <slot />
          </v-col>
        </v-row>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['title', 'loading']
}
</script>

<style scoped>
.root >>> .v-skeleton-loader__heading {
  background-color: #E4E6EB !important;
}
h1 {
  font-style: normal;
  font-weight: 500;
  font-size: 2rem;
  line-height: 2.4375rem;
  letter-spacing: 0.1px;
  color: #234025;
}
@media screen and (max-width: 600px) {
  h1 {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
}
</style>
